import React from 'react';
import PropTypes from 'prop-types';

import { withTheme } from '@material-ui/core/styles';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconInsurance = ({ theme, ...otherProps }) => (
  <SvgIcon {...otherProps} viewBox="0 0 53.9814 70.948639">
    <path fill={theme.palette.primary.A400} transform="translate(0 0)" d="m53.981 19.504c0 20.449-9.7504 39.556-26.017 51.122 0 0-0.4654 0.3273-0.9736 0.3231-0.508-0.005-0.973-0.323-0.973-0.323-16.267-11.566-26.017-30.673-26.017-51.122v-10.165c0-0.6155 0.39094-1.1581 0.96164-1.3351l25.641-7.9451c0.253-0.078394 0.5227-0.078394 0.7757 0l25.641 7.9451c0.5708 0.17697 0.9618 0.71961 0.9618 1.3351v10.165z" />
    <path fill={theme.palette.grey[100]} transform="translate(2.75 4)" d="m48.483 17.517c0 18.366-9.6316 35.97-24.241 46.358-14.61-10.387-24.242-27.992-24.242-46.358v-9.1293c0-0.5528 0.35112-1.0402 0.86368-1.1991l23.029-7.1358c0.2273-0.070409 0.4694-0.070409 0.6967 0l23.029 7.1358c0.5127 0.15894 0.8638 0.64631 0.8638 1.1991v9.1295z" />
    <path fill={theme.palette.primary.A100} transform="translate(4.05 4)" d="m22.942 61.91c-14.416-10.885-22.942-28.142-22.942-46.71v-8.0912l22.942-7.1088 22.942 7.1088v8.0908c0 18.568-8.5266 35.826-22.942 46.71z" />
    <path fill={theme.palette.grey[100]} transform="translate(28.17 10)" d="m21.76 1.5053v8.0909c0 18.054-8.062 34.868-21.76 45.791 10.725-12.612 16.901-29.981 16.901-48.462v-6.9249l4.8584 1.5053z" />
    <path fill={theme.palette.primary.A400} transform="translate(11.47 14)" d="m15.52 32.059c-8.5715 0-15.52-7.177-15.52-16.029 0-8.8534 6.9484-16.03 15.52-16.03 8.5713 0 15.52 7.1768 15.52 16.03 0 8.8529-6.9485 16.03-15.52 16.03z" />
    <path fill={theme.palette.primary.A100} transform="translate(14.21 17)" d="m12.784 26.409c-7.0602 0-12.784-5.912-12.784-13.205 0-7.2922 5.7238-13.204 12.784-13.204 7.0607 0 12.784 5.9119 12.784 13.204 0 7.2927-5.7239 13.204-12.784 13.204z" />
    <path fill={theme.palette.common.white} transform="translate(18.98 22)" d="m16.025 5.1546h-5.015v-5.1546h-5.9945v5.1546h-5.0156v6.1614h5.0156v5.1542h5.9945v-5.1542h5.015v-6.1614z" />
  </SvgIcon>
);

IconInsurance.propTypes = {
  theme: PropTypes.shape({
    palette: PropTypes.shape({
      primary: PropTypes.shape({
        A100: PropTypes.string.isRequired,
        A400: PropTypes.string.isRequired,
      }).isRequired,
      grey: PropTypes.shape({
        100: PropTypes.string.isRequired,
      }).isRequired,
      common: PropTypes.shape({
        white: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

export default withTheme()(IconInsurance);



// WEBPACK FOOTER //
// ./src/components/icons/IconInsurance.js